import { COURSE_IDS } from './courseOptions';

export type DrivingChallengeId =
  | 'free-drive'
  | 'zero-to-100'
  | 'top-speed'
  | 'braking-100'
  | 'hill-climb';

export interface DrivingChallengeOption {
  id: DrivingChallengeId;
  name: string;
  description: string;
  icon: string;
  requiredCourseId?: string;
}

export const drivingChallengeOptions: readonly DrivingChallengeOption[] = [
  { id: 'free-drive', name: '자유 주행', description: '제한 없이 코스와 차량 체험', icon: '∞' },
  { id: 'zero-to-100', name: '0→100', description: '정지 상태에서 100km/h 도달 시간', icon: '⚡' },
  { id: 'top-speed', name: '최고속도', description: '30초 동안 최고속도 기록', icon: '▲', requiredCourseId: COURSE_IDS.SPEED_RING },
  { id: 'braking-100', name: '100→0 제동', description: '100km/h에서 완전 정지 거리', icon: '■' },
  { id: 'hill-climb', name: '힐클라임', description: '고저차 코스 결승선까지 기록', icon: '⌁', requiredCourseId: COURSE_IDS.ELEVATION_RUN },
];

export const DEFAULT_DRIVING_CHALLENGE_ID: DrivingChallengeId = 'free-drive';

export function findDrivingChallengeById(id: string): DrivingChallengeOption | undefined {
  return drivingChallengeOptions.find((option) => option.id === id);
}
